import { render, staticRenderFns } from "./CardExtratoClienteMobile.vue?vue&type=template&id=5cf74f1a&scoped=true&"
import script from "./CardExtratoClienteMobile.vue?vue&type=script&lang=js&"
export * from "./CardExtratoClienteMobile.vue?vue&type=script&lang=js&"
import style0 from "./CardExtratoClienteMobile.vue?vue&type=style&index=0&id=5cf74f1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf74f1a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
